// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"48":"80f87bdc584e53c0","697":"335a7dea212ace55"}[chunkId] + ".js";
};